export const LIVE_FEED_TYPE_TYPE = {
    THEATRE_CASES: 'theatre_cases'
};

export const LIVE_FEED_TYPE_TYPE_IDS = {
    [LIVE_FEED_TYPE_TYPE.THEATRE_CASES]: 1
};

export const LIVE_FEED_TYPE_TYPE_TITLES = {
    [LIVE_FEED_TYPE_TYPE.THEATRE_CASES]: 'Theatre Cases'
};

export const LIVE_FEED_TYPE_TYPES = [
    {
        id: LIVE_FEED_TYPE_TYPE_IDS[LIVE_FEED_TYPE_TYPE.THEATRE_CASES],
        name: LIVE_FEED_TYPE_TYPE_TITLES[LIVE_FEED_TYPE_TYPE.THEATRE_CASES],
        alias: LIVE_FEED_TYPE_TYPE.THEATRE_CASES
    }
];
